import React from "react";
import { Chip, Group } from '@mantine/core';

import { utils } from "../../utils/globalVariables";

const GenderMaleFemaleUngenderedSelectorMultiple = ({
    stateValue = [],
    fnOnChange,

    stateController = true,
    fnController,
}) => {
    return (
        <React.Fragment>
            <Group spacing='xs'>
                <Chip
                    checked={stateController}
                    onChange={fnController}
                    radius='sm'
                >
                    Semua
                </Chip>

                <Chip.Group
                    multiple
                    value={stateValue}
                    onChange={fnOnChange}
                >
                    <Group spacing='xs'>
                        {Object.keys(utils.gender).map((key, index) => {
                            return (
                                <Chip
                                    key={key}
                                    value={String(utils.gender[key].value)}
                                    radius='sm'
                                >
                                    {utils.gender[key].caption}
                                </Chip>
                            )
                        })}
                    </Group>
                </Chip.Group>
            </Group>
        </React.Fragment>
    )
}

export default GenderMaleFemaleUngenderedSelectorMultiple;